import dayjs from "dayjs";
import { REPORT } from "../utils/Struct";
import { getDefaultColumns } from "../components/ReportColumns";

export const getReportTemplate = (_template_id, _group) => {

    let _ret = { ...REPORT };

    _ret.group = _group;
    _ret.columns = getDefaultColumns().map((item, index) => {
        return ({
            "position": index,
            "column_id": (item?.filter_id) ? item.filter_id : "",
            "display_name": item.title,
            "size": Math.ceil(item.width),
            "type": item.value
        })
    });

    switch (_template_id) {

        case 1:

            _ret.filters = [
                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 0,
                    "type": 35,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                }
            ]
            break;

        case 2:
            _ret.name = "Sales";
            _ret.scope_type = 2;
            _ret.order_1 = 14;
            _ret.filters = [
                {
                    "filter_id": "",
                    "comparison": "",
                    "ordering": 0,
                    "type": -5,
                    "value_1": dayjs().add(-1, "day").format("YYYY-MM-DD") + " 00:00:00",
                    "value_2": dayjs().format("YYYY-MM-DD") + " 23:59:00",
                    "where_type": "AND"
                },

                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 1,
                    "type": -7,
                    "value_1": "S|H|A|P|F",
                    "value_2": "",
                    "where_type": "AND"
                },

                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 0,
                    "type": 35,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                },
                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 1,
                    "type": 43,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                }
            ]
            break;
        default:
            break;

    }


    return _ret;

}